// extracted by mini-css-extract-plugin
module.exports = {"balance":"Balance_balance__18oN1","amount":"Balance_amount__3mvFW","icon":"Balance_icon__1SLWy"};